import { InputConverterFunc } from '../../../../inputConverter';

export type IconColors = 'default' | 'green' | 'light-blue' | 'blue' | 'dark-blue ' | 'purple' | 'orange' | 'gray' | 'red' | 'yellow';

export default class DistanceMeasurementConfiguration {
    constructor(config?: DistanceMeasurementConfiguration) {
        if (config) {
            Object.assign(this, config);
        }
    }

    /**
     * Class that determines which icon is used for the button.
     *
     * @Default 'esri-icon-minus'
     */
    iconClass?: string = 'esri-icon-polyline';

    /**
     * The threshold distance used by the "auto" mode to switch between planar and geodesic linear computations. The threshold is measured in meters.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-DistanceMeasurement2D-DistanceMeasurement2DViewModel.html#geodesicDistanceThreshold)
     *
     */
    geodesicDistanceThreshold?: number = 100000;

    /**
     * Unit system (imperial, metric) or specific unit used for displaying the distance values.  **Possible Values:** metric | imperial | inches | feet | us-feet | yards | miles | nautical-miles | meters | kilometers
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-DistanceMeasurement2D-DistanceMeasurement2DViewModel.html#unit)
     */
    unit?: __esri.SystemOrLengthUnit = 'miles';

    /**
     * List of available units and unit systems (imperial, metric) for displaying the distance values. By default, the following units are included: `metric`, `imperial`, `inches`, `feet`, `us-feet`, `yards`, `miles`, `nautical-miles`, `meters`, `kilometers`.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-DistanceMeasurement2D-DistanceMeasurement2DViewModel.html#unitOptions)
     */
    unitOptions?: string[];
}

export let DistanceMeasureConfigurationConverter: InputConverterFunc<DistanceMeasurementConfiguration> = (value: any) => {
    if (typeof value === 'string') {
        return new DistanceMeasurementConfiguration(<DistanceMeasurementConfiguration>JSON.parse(value));
    }
    return value;
};
